import { render, staticRenderFns } from "./BaseSearchForm.vue?vue&type=template&id=5b602974&scoped=true&"
import script from "./BaseSearchForm.vue?vue&type=script&lang=js&"
export * from "./BaseSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchForm.vue?vue&type=style&index=0&id=5b602974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b602974",
  null
  
)

export default component.exports